import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LangToggle } from "@/components/LangToggle";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/lib/i18n";
import { LogOut, Pencil, Film } from "lucide-react";
import { Button } from "@/components/ui/button";

export function CorpHeader() {
  const { user, logout } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  return (
    <header className="bg-white border-b border-stone-200 sticky top-0 z-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-2">
        <Link to="/admin" className="flex items-center gap-3 shrink-0" data-testid="corp-logo-link">
          <img
            src="/corp-logo.png"
            alt="Relax-MIS"
            className="h-9 sm:h-10 w-auto"
          />
          <span className="hidden md:inline caption-label border-l border-stone-200 pl-3 ml-1 text-stone-500">
            Super Admin Console
          </span>
        </Link>
        <div className="flex items-center gap-1.5 sm:gap-3 flex-wrap justify-end">
          <LangToggle variant="light" />
          {user && (
            <>
              {user.role === "super_admin" && (
                <>
                  <Button
                    asChild
                    variant="ghost"
                    size="sm"
                    className="text-stone-700 hover:bg-stone-100 px-2 sm:px-3"
                    data-testid="corp-edit-landing-link"
                  >
                    <Link to="/admin/landing">
                      <Pencil className="w-3.5 h-3.5 sm:mr-1.5" />
                      <span className="hidden sm:inline">{t("admin.nav.edit_landing")}</span>
                    </Link>
                  </Button>
                  <Button
                    asChild
                    variant="ghost"
                    size="sm"
                    className="text-stone-700 hover:bg-stone-100 px-2 sm:px-3"
                    data-testid="corp-promo-videos-link"
                  >
                    <Link to="/admin/promo-videos">
                      <Film className="w-3.5 h-3.5 sm:mr-1.5" />
                      <span className="hidden sm:inline">{t("admin.nav.promo_videos")}</span>
                    </Link>
                  </Button>
                </>
              )}
              <span className="hidden sm:block font-mono text-xs text-stone-500" data-testid="admin-logged-in-name">
                {user.name && user.name !== "Administrator" ? user.name : user.email}
              </span>
              <Button
                variant="ghost"
                size="sm"
                onClick={async () => { await logout(); nav("/login"); }}
                className="text-stone-700 hover:bg-stone-100 px-2 sm:px-3"
                data-testid="admin-logout-button"
              >
                <LogOut className="w-3.5 h-3.5 sm:mr-1.5" />
                <span className="hidden sm:inline">{t("admin.dashboard.logout")}</span>
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
